import { ChevronDown } from "lucide-react"

export const ScrollIndicator = ({ onClick }) => {
    return (
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce cursor-pointer" onClick={onClick}>
            <ChevronDown className="h-8 w-8 text-igbanwo-mint" />
        </div>
    )
}